import { Plus } from "lucide-react"

import { Button } from "@/components/ui/button"
import { EmptyState } from "@/components/ui/empty-state"

export function EmptyStatePreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">EmptyState</h1>
      </header>

      <div className="grid gap-5 lg:grid-cols-2">
        <EmptyState
          reason="empty"
          title="No reviews yet"
          body="Start one by uploading a printed label and the approved master it should match."
          action={
            <Button variant="primary" leadingIcon={<Plus />}>
              Start a review
            </Button>
          }
        />
        <EmptyState
          reason="filtered"
          title="Nothing matches"
          body="The reviews are still there — the filter is hiding them."
        />
        <EmptyState
          reason="error"
          title="Couldn't load reviews"
          body="Something went wrong reaching the API. Try again — if it keeps happening, tell Kostya."
          action={<Button>Try again</Button>}
        />
        <div className="rounded-lg border border-border bg-surface">
          <div className="border-b border-border px-4 py-2.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
            Bare (inside a DataTable body)
          </div>
          <EmptyState bare title="No matches on this page" />
        </div>
      </div>
    </div>
  )
}
